module.exports = __webpack_public_path__ + "static/pA6-93418b8cb10ad8f37debe27ab0b848b2.png";